export default __webpack_public_path__ + "static/media/shell-exchange.859b7f22.jpg";